/**
 * Shared celebration date helpers — used by Orders action rail, dashboard
 * revitalize eligibility, and approved-pending-order queries.
 */

export function startOfTodayLocal(): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

/** True when the celebration date is strictly before today (local time). */
export function isPastCelebrationDate(
  date: string,
  today: Date = startOfTodayLocal(),
): boolean {
  return new Date(date + "T00:00:00") < today;
}

/** Revitalize is only for celebrations explicitly marked skipped in the DB. */
export function canRevitalizeCelebration(
  celebration: { status?: string | null } | null | undefined,
): boolean {
  return celebration?.status === "skipped";
}
